/**
 * 내 리뷰 중 score가 확정된 개수 기준 (백엔드 RankingController와 동일).
 * 미만이면 랭킹 목록 비노출·리뷰 작성 시 AB(이상형 비교) 미진입.
 */
export const MIN_SCORED_USER_REVIEWS_FOR_RANKING = 3
